import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { selectUserSignedConsents } from '../../../../redux/profiles/selectors';
import styles from './index.styl';
import RenderViewConsents from '../RenderViewConsents';

const Consents = ({ formatMessage }) => {
  const allConsents = useSelector(selectUserSignedConsents);
  const hasConsentsForm = Boolean(allConsents.length);

  return (
    <div className={styles.wrapper}>
      <div className={styles.sectionTitle}>
        {formatMessage({ id: 'appointment.consent.title' })}
      </div>
      {hasConsentsForm
        ? allConsents.map(({ organization, consents }) => {
            return (
              <div className={styles.content} key={organization.id}>
                <div className={styles.organizationName}>
                  {organization.name}
                </div>
                <RenderViewConsents
                  consentsList={consents}
                  formatMessage={formatMessage}
                />
              </div>
            );
          })
        : '-'}
    </div>
  );
};

Consents.propTypes = {
  formatMessage: PropTypes.func,
};

export default memo(Consents);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/ProfileDocumentation/Consents/index.jsx